import { Button, Card, Col, DatePicker, Form, notification, Row, Space, Tooltip } from 'antd'
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf } from '../../../utils/pdf';
import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined, SearchOutlined } from '@ant-design/icons';
import TableView from '../../../../contents/AntTableResponsive';
import { SelectSession } from '../../../select/SelectSession';
import { SelectClass } from '../../../select/SelectClass';
import { SelectDepartmentByClass } from '../../../select/SelectDepartmentByClass';
import { SelectSemesterYearByClass } from '../../../select/SelectSemesterYearByClass';
import ReactExport from "react-data-export";
import { Excel } from 'antd-table-saveas-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let excelx: any = [];
let tempCol: any = []
let tempExcelCol: any = []

export default function HeadCollectionStudentDateOnly(props) {

    const onlyDateToDateStudentFeeHeadCollection = useStoreState((state) => state.payslip.onlyDateToDateStudentFeeHeadCollection);
    const feeHeadNames = useStoreState((state) => state.payslip.feeHeadNames);
    const fetchonlyDateToDateStudentFeeHeadCollection = useStoreActions((state) => state.payslip.fetchonlyDateToDateStudentFeeHeadCollection);

    const [reportForm] = Form.useForm();

    const reportFormSubmit = (value) => {

        tempCol=[];
        tempExcelCol=[];

        setexcelHead(['Student Id', 'Student Name', 'Roll'])

        setcolumns([{
            title: 'Student Id',
            dataIndex: 'customStudentId',
            key: 'customStudentId',
            showOnResponse: true,
            showOnDesktop: true,
        },

        {
            title: 'Student Name',
            dataIndex: 'studentName',
            key: 'studentName',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Session',
            dataIndex: 'session',
            key: 'session',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Class',
            dataIndex: 'className',
            key: 'className',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
            showOnResponse: true,
            showOnDesktop: true,
        },       
        {
            title: 'Semester',
            dataIndex: 'semester',
            key: 'semester',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Roll',
            dataIndex: 'studentRoll',
            key: 'studentRoll',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            showOnResponse: true,
            showOnDesktop: true,
        },
        ])
        value.fromDate = moment(value?.fromDate).format("YYYY-MM-DD");
        value.toDate = moment(value?.toDate).format("YYYY-MM-DD");
        fetchonlyDateToDateStudentFeeHeadCollection(value);
    };






    const [columns, setcolumns] = useState<any>([]);
    const [excelHead, setexcelHead] = useState<any>([]);

    useEffect(() => {

        tempCol = []
        tempExcelCol = []

        Object.entries(feeHeadNames).forEach(([key, value], index) => {
            let temp: any = {
                title: value,
                dataIndex: `feeHead${index + 1}`,
                key: `feeHead${index + 1}`,
                showOnResponse: true,
                showOnDesktop: true,
            };
            let temExcel = value
            tempCol.push(temp)
            tempExcelCol.push(temExcel)
        });
        // console.log("tempCol", tempCol)
        let final = [].concat(columns, tempCol);
        setexcelHead(tempExcelCol)
        // console.log("final", finalExcel)
        setcolumns(final)

        tempExcelCol.forEach((element, index) => {
            excelx.push(<ExcelColumn label={element} value={`feeHead${index + 1}`} />)
        })


    }, [feeHeadNames])




    return (
        <>

            <Form
                layout="vertical"
                onFinish={reportFormSubmit}
                id="basic-info"
                form={reportForm}
            >
                <Row gutter={8}>
                   
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}></Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                        <Form.Item
                            name="fromDate"
                            label="From Date"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please enter from date" },
                            ]}
                        >

                            <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                        <Form.Item
                            name="toDate"
                            label="To Date"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please enter to date" },
                            ]}
                        >

                            <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                        <Space size="small" >
                            <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                Search
                            </Button>
                        </Space>
                    </Col>

                </Row>
            </Form>
            {onlyDateToDateStudentFeeHeadCollection !== null &&
                <>
                    <div className="datatable-responsive">
                        {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} className="p-datatable-responsive-demo" /> */}

                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns,
                                dataSource: onlyDateToDateStudentFeeHeadCollection,
                                pagination: true,
                                bordered: true,
                                rowKey: "identificationId",
                            }}
                            mobileBreakPoint={768}
                        />
                    </div>
                    <Space size="middle" style={{ float: "right", marginTop: 15 }}>

                        {/* <ExcelFile element={<Button type="primary" icon={<FileExcelOutlined />} >Download Excel</Button>}>
                            <ExcelSheet data={onlyDateToDateStudentFeeHeadCollection} name="Data">
                                <ExcelColumn label="Student Id" value="customStudentId" />
                                <ExcelColumn label="Student Name" value="studentName" />
                                <ExcelColumn label="Roll" value="studentRoll" />
                                {excelx}
                                <ExcelColumn label="Total" value="total" />
                            </ExcelSheet>
                        </ExcelFile> */}

                        < Button
                                type='primary'

                                icon={<FileExcelOutlined />}
                                onClick={() => {
                                    const excel: any = new Excel();
                                    excel
                                        .addSheet(`Sheet 1`)
                                        .addColumns(columns)
                                        .addDataSource(onlyDateToDateStudentFeeHeadCollection)
                                        .saveAs(`Student Head Collection.xlsx`);
                                }}
                            >
                                Download Excel
                            </ Button >

                    </Space>
                </>
            }

        </>
    )
}
